<template>
  <div>
    <el-container class="careStaffLibrary">
      <el-card class="tabs-card">
        <el-form
          :inline="true"
          ref="formRef"
          :model="tableParams"
          class="demo-form-inline"
        >
          <!-- <el-form-item label="设施类别" prop="">
            <h-selectcode
              type="facilityType"
              v-model="tableParams.syxz"
              placeholder="设施类别"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item>
            <h-button type="primary" @click="refreshTable">查询</h-button>
            <h-button @click="resetForm(formRef)">重置</h-button>
          </el-form-item> -->
          <el-row>
            <el-col style="display: flex">
              <h-button plain type="primary" @click="selectButton">
                <el-icon><full-screen /></el-icon>选择
              </h-button>
              <h-button plain type="primary" @click="addButton">
                <el-icon><plus /></el-icon>新建
              </h-button>
              <h-button
                :disabled="tableSelection.length === 0"
                plain
                type="danger"
                @click="delUser"
              >
                <el-icon><delete /></el-icon>删除
              </h-button>
              <!-- <input type="file" v-show="false" ref="file" @change="myup" />
              <h-button @click="excel(3)" plain type="primary">
                <el-icon><upload /></el-icon>导入
              </h-button> -->
              <h-button @click="excel(2)" plain type="primary">
                <el-icon><download Upload /></el-icon>导出
              </h-button>
              <h-button @click="excel(1)" plain type="primary">
                <el-icon><download Upload /></el-icon>下载模板
              </h-button>
            </el-col>
          </el-row>
        </el-form>
        <div class="table-box">
          <h-table
            ref="tableRef"
            style="height: 500px"
            v-model:data="tableData"
            v-model:columns="columns"
            :method="peoplegetprison"
            :params="tableParams"
            @handleClick="handleClick"
            @select="hzTableSelect"
          >
            <template #name="{ row }">
              <u @click="nameCLickDialog(row)" class="table-row-name">{{
                row.name
              }}</u>
            </template>

            <template #imageUrl="{ row }">
              <!-- && row.imageUrl.indexOf('http') == -1 -->
              <span v-if="!row.imageUrl">{{ "暂无" }}</span>
              <img v-else :src="imgURL + row.imageUrl" />
            </template>
          </h-table>
        </div>
      </el-card>
    </el-container>
    <el-dialog
      v-model="formVisible"
      :title="'人员' + (status === 1 ? '新增' : status === 2 ? '编辑' : '详情')"
      width="50%"
    >
      <personnel-detail
        v-if="formVisible"
        v-model="formVisible"
        :form="userFormData"
        :addAndAdd="true"
        :careLibraryCareId="form.careId"
        :status="status"
        :careLibrary="true"
        @submit="refreshTable"
      ></personnel-detail>
    </el-dialog>
    <el-dialog
      v-model="formVisibleobject"
      top="20vh"
      title="选择对象"
      width="70%"
    >
      <select-object
        v-if="formVisibleobject"
        @tableSelectionObj="tableSelectionObj"
        @cancel="cancel"
      ></select-object>
    </el-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  nextTick,
} from "vue";
import { ElMessageBox, ElMessage, genFileId } from "element-plus";
import {
  FullScreen,
  Plus,
  Delete,
  Download,
  Upload,
} from "@element-plus/icons-vue";
import selectObject from "./selectObject.vue";
import {
  peoplegetprison,
  prisonsave,
  prisondelete,
  careprisonimport,
  careprisonexport,
} from "@/api/communityCare/communityCareApi.js";
export default defineComponent({
  components: { FullScreen, Plus, Delete, Download, Upload, selectObject },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const formRef = ref(null);
    const tableRef = ref(null);
    const state = reactive({
      imgURL: window.imgURL,
      formVisible: false,
      formVisibleobject: false,
      tableParams: {
        careId: "",
      },
      userFormData: {},
      status: 1,
      columns: [
        { type: "selection" },
        {
          label: "图片",
          slot: "imageUrl",
        },
        {
          label: "姓名",
          hidden: true,
          slot: "name",
          // prop: "name"
        },
        {
          label: "性别",
          prop: "sexDict", // sex
        },
        {
          label: "证件号码",
          prop: "cardNumber",
        },
        {
          label: "民族",
          prop: "nationDict", // nation
        },
        {
          label: "居住地址",
          prop: "registerDetail",
        },
        {
          label: "电话",
          prop: "telphone",
        },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      tableData: [],
      tableSelection: [],
    });

    const methods = {
      // 添加弹框
      addButton() {
        state.formVisible = true;
        state.status = 1;
      },
      selectButton() {
        state.formVisibleobject = true;
      },
      // 删除
      delUser() {
        ElMessageBox.confirm("您确认要删除该人员吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => {
              return item.prisonId;
            });
            methods.deleteAxios(ids);
          },
          () => {}
        );
      },
      nameCLickDialog(row) {
        state.formVisible = true;
        state.status = 3;
        state.userFormData = row;
      },
      // 删除
      async deleteAxios(id) {
        const params = {
          ids: id,
          careId: props.form.careId,
        };
        const res = await prisondelete(params);
        if (res.code === 0) {
          ElMessage.success("删除成功");
          methods.refreshTable();
        }
      },
      // 点击table操作按钮
      handleClick(operate, row) {
        const { emitKey } = operate;
        if (emitKey === "del") {
          ElMessageBox.confirm("您确认要删除该人员吗？", "删除", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(
            () => {
              methods.deleteAxios([row.prisonId]);
            },
            () => {}
          );
        } else if (emitKey === "edit") {
          state.formVisible = true;
          state.status = 2;
          state.userFormData = row;
        }
      },

      // 当用户手动勾选数据行的 Checkbox 时触发的事件
      hzTableSelect(selection) {
        state.tableSelection = selection;
      },
      refreshTable() {
        tableRef.value && tableRef.value.refresh();
      },
      // 取消
      cancel() {
        state.formVisibleobject = false;
      },
      // 添加
      async tableSelectionObj(select) {
        const prisonIds = select.map((item) => {
          return item.prisonId;
        });
        const params = {
          prisonIds,
          careId: props.form.careId,
        };
        const res = await prisonsave(params);
        tableRef.value.tableData = tableRef.value.tableData.concat(select);
        methods.cancel();
        methods.refreshTable();
      },
    };
    watchEffect(() => {
      state.tableParams.careId = props.form.careId;
      nextTick(() => {
        methods.refreshTable();
      });
    });
    const file = ref();
    const excel = async (is) => {
      let res = "";
      if (is === 1) {
        window.open(window.xlsxUrl + "实有人口信息导入模板.xlsx");
        return;
      } else if (is === 2) {
        res = await careprisonexport(tableRef.value.form);
      } else {
        file.value.click();
        return;
        // res = await careprisonimport({ careId: props.form.careId });
      }
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("careId", props.form.careId); // 添加form表单中其他数据
      console.log(file.name, param);
      // if (file.name.substring(11, 15) !== "xlsx") {
      //   state.flag = true;
      // } else {
      const result = await careprisonimport(param);
      if (result.code == 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "上传成功",
        });
      }

      // }
    };

    return {
      ...toRefs(state),
      myup,
      ...methods,
      formRef,
      tableRef,
      excel,
      file,
      peoplegetprison,
    };
  },
});
</script>
<style lang="scss" scoped>
.careStaffLibrary {
  width: 100%;
  img {
    width: 42%;
    height: 90px;
  }
  .tabs-card {
    width: 100%;
    .table-box {
      height: 100%;
      .table-row-name {
        cursor: pointer;
        color: #1887ff;
      }
    }
  }
}
</style>
